import { Box } from "@mui/material";
import React from "react";
import classess from "./Style.module.css";

const UM = () => {
  const Title = ["کاربرد", "معنی", "ساختار"];
  const ST1 = ["زمان", "در ساعتِ ...", "um + ساعت"];
  const ST2 = ["هدف", "برای اینکه ...", "um ... zu + فعل"];
  const ST3 = ["اطراف", "دور چیزی", "um + Akk + herum"];
  return (
    <Box className={classess.Wrapper}>
      <span>خلاصه جدول:</span>
      <Box className={classess.WP}>
        {Title.map((opt, index) => (
          <Box
            key={index}
            className={classess.WB}
            sx={{
              width: index === 2 ? "130px" : "100px",
              backgroundColor: "rgba(150, 150, 150, 0.1)",
              fontSize: "0.9rem",
            }}
          >
            {opt}
          </Box>
        ))}
      </Box>
      <Box className={classess.WP}>
        {ST1.map((opt, index) => (
          <Box
            key={index}
            className={classess.WB}
            sx={{
              width: index === 2 ? "130px" : "100px",
              fontSize: "1.1rem",
            }}
          >
            {opt}
          </Box>
        ))}
      </Box>
      <Box className={classess.WP}>
        {ST2.map((opt, index) => (
          <Box
            key={index}
            className={classess.WB}
            sx={{
              width: index === 2 ? "130px" : "100px",
              fontSize: "1.1rem",
            }}
          >
            {opt}
          </Box>
        ))}
      </Box>
      <Box className={classess.WP}>
        {ST3.map((opt, index) => (
          <Box
            key={index}
            className={classess.WB}
            sx={{
              width: index === 2 ? "130px" : "100px",
              fontSize: "1.1rem",
            }}
          >
            {opt}
          </Box>
        ))}
      </Box>
    </Box>
  );
};

export default UM;
